// extracted by mini-css-extract-plugin
export default {"container":"ScrollTopButton_container_RTSoP","icon":"ScrollTopButton_icon_JtpJQ"};